import Context from "../../context/Context";
import * as projectionUtil from "../../../src/util/projectionUtil";

export async function goToGeometry(view, targetGeometry, purpose) {
  const lib = Context.instance.lib;
  let bufferMeters = 10;
  if (purpose === "unit_level") bufferMeters = 25

  const addZ = (extent,z) => {
    const ext = new lib.esri.Extent({
      "xmin": extent.xmin,
      "xmax": extent.xmax,
      "ymin": extent.ymin,
      "ymax": extent.ymax,
      "zmin": z,
      "zmax": z,
      spatialReference: extent.spatialReference
    });
    return ext;
  };

  if (!targetGeometry) return Promise.resolve();
  // TODO need a different approach for 3D?
  // TODO jsapi3 has map.setExtent(extent, fit?), equivalent in 4?
  const is3D = (view && view.type === "3d");
  let geometry = null, target = null, heading = null, tilt = null;
  if (targetGeometry.type === "point") {
    geometry = projectionUtil.geodesicBuffer(targetGeometry, bufferMeters);
    if (geometry && geometry.extent) {
      geometry = geometry.extent;
      const z = (typeof targetGeometry.z === "number") ? targetGeometry.z : 0;
      geometry = addZ(geometry.extent,z);
      target = {target: geometry};
    }
  } else if (targetGeometry.extent) {
    const ext = targetGeometry.extent.clone();
    geometry = projectionUtil.geodesicBuffer(ext, bufferMeters);
    if (geometry && geometry.extent) {
      geometry = geometry.extent;
      const z = (typeof ext.zmin === "number") ? ext.zmin : 0;
      geometry = addZ(geometry.extent,z);
      target = {target: geometry};
    }
  } else {
    target = {target: geometry};
  }
  const options = {
    duration: 1000,
    easing: "out-back"
  };

  if (is3D) {
    if (view.camera) {
      //console.log("camera.heading",view.camera.heading,"camera.tilt",view.camera.tilt);
      heading = view.camera.heading;
      //tilt = view.camera.tilt;
      tilt = 60;
    }
    if (typeof heading === "number") target.heading = heading;
    if (typeof tilt === "number") target.tilt = tilt;
  }

  if (target) {
    return view.goTo(target,options).then(() => {
      if (!is3D && !view.extent.contains(geometry)) {
        //console.log("view.extent",view.extent,"geometry",geometry);
        view.zoom -= 1;
      }
    });
  } else {
    return Promise.resolve();
  }
}

export function hasPointGeometry(feature) {
  let ok = !!(feature && feature.geometry);
  if (ok) {
    let x = feature.geometry.x;
    let y = feature.geometry.y;
    if (x === null || y === null || (x === 0 && y === 0)) {
      ok = false;
    }
  }
  return ok;
}
